// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/binary/binary.proto" (package "mlmbox.client.binary", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Binary } from "./binary.ts";
import type { Binary_Position } from "../../types/account.ts";
import type { Binary_BranchSelectStrategy_Request } from "../../types/account.ts";
import type { Binary_View } from "../../types/account.ts";
import type { PositionView_Team } from "../../types/account.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Binary_Info } from "../../types/account.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.binary.Binary
 */
export interface IBinaryClient {
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Binary.Info);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Binary_Info>;
    /**
     * @generated from protobuf rpc: View(mlmbox.types.PositionView.Team) returns (mlmbox.types.Binary.View);
     */
    view(input: PositionView_Team, options?: RpcOptions): UnaryCall<PositionView_Team, Binary_View>;
    /**
     * @generated from protobuf rpc: SetPositionBranchSelectStrategy(mlmbox.types.Binary.BranchSelectStrategy.Request) returns (mlmbox.types.Binary.Position);
     */
    setPositionBranchSelectStrategy(input: Binary_BranchSelectStrategy_Request, options?: RpcOptions): UnaryCall<Binary_BranchSelectStrategy_Request, Binary_Position>;
}
/**
 * @generated from protobuf service mlmbox.client.binary.Binary
 */
export class BinaryClient implements IBinaryClient, ServiceInfo {
    typeName = Binary.typeName;
    methods = Binary.methods;
    options = Binary.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Binary.Info);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Binary_Info> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Binary_Info>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: View(mlmbox.types.PositionView.Team) returns (mlmbox.types.Binary.View);
     */
    view(input: PositionView_Team, options?: RpcOptions): UnaryCall<PositionView_Team, Binary_View> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<PositionView_Team, Binary_View>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetPositionBranchSelectStrategy(mlmbox.types.Binary.BranchSelectStrategy.Request) returns (mlmbox.types.Binary.Position);
     */
    setPositionBranchSelectStrategy(input: Binary_BranchSelectStrategy_Request, options?: RpcOptions): UnaryCall<Binary_BranchSelectStrategy_Request, Binary_Position> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<Binary_BranchSelectStrategy_Request, Binary_Position>("unary", this._transport, method, opt, input);
    }
}
